export default __webpack_public_path__ + "e3c6c24e00a116c94797988d08c76570.png";